import { ExpandMore, Menu } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { LogReportMode } from '../../utils';
import { SearchBar } from 'ui-component/SearchBar';
import { LogReportType } from 'ui-component/RecordView/types';
import { LogReportHeaderButtons } from './LogReportHeaderButtons';
import { LogReportHeaderMenu } from './LogReportHeaderMenu';

export type LogReportSelectorProps = {
    onChangeSelection: (newSelection: LogReportMode) => void;
    setButtonTypeLog?: (newSelection: LogReportType) => void;
    buttonTypeLog: LogReportType;
    toggleLogReport?: () => void;
    setSearchInput?: (value: string) => void;
    searchInput?: string;
};

export const LogReportSelector = ({
    onChangeSelection,
    setButtonTypeLog,
    buttonTypeLog,
    toggleLogReport,
    setSearchInput,
    searchInput
}: LogReportSelectorProps) => {
    const [anchorRef, setAnchorRef] = useState<HTMLElement | null>(null);

    const handleOpen = (e: MouseEvent<HTMLButtonElement>) => {
        setAnchorRef(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorRef(null);
        toggleLogReport?.();
    };

    const handleChangeSelection = (newSelection: LogReportMode) => () => {
        onChangeSelection(newSelection);
        setAnchorRef(null);
    };

    return (
        <Box
            id="logReportSelectorId"
            sx={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '5px',
                bgcolor: '#F5F6F7'
            }}
        >
            <LogReportHeaderButtons buttonTypeLog={buttonTypeLog} setButtonTypeLog={setButtonTypeLog} handleClose={handleClose} />

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%'
                }}
            >
                <SearchBar
                    value={searchInput}
                    placeholder="Find in current page"
                    size="small"
                    InputProps={{ sx: { bgcolor: 'white' } }}
                    onChange={(e) => setSearchInput?.(e.target.value)}
                    hideKeys
                />
                <Button
                    size="medium"
                    color="primary"
                    onClick={handleOpen}
                    sx={(theme) => ({
                        color: theme.palette.primary[400],
                        backgroundColor: '#FFF',
                        fontWeight: 600,
                        borderRadius: '30px',
                        '&:hover': { color: theme.palette.primary[400], backgroundColor: theme.palette.primary[300] }
                    })}
                >
                    <Menu fontSize="medium" />
                    <ExpandMore fontSize="medium" />
                </Button>
                <LogReportHeaderMenu anchorRef={anchorRef} onClose={handleClose} onChangeSelection={handleChangeSelection} />
            </Box>
        </Box>
    );
};
